const menuItems = {
  items: [
    {
      id: 'routes',
      title: 'routes',
      type: 'group',
      icon: 'icon-navigation',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-home',
          url: '/dashboard'
        },
        {
          id: 'table',
          title: 'Customers',
          type: 'item',
          icon: 'feather icon-server',
          url: '/customers'
        },
        {
          id: 'table',
          title: 'Tracking',
          type: 'item',
          icon: 'feather icon-trending-up',
          url: '/tracking'
        },
        {
          id: 'table',
          title: 'Chats',
          type: 'item',
          icon: 'feather icon-mail',
          url: '/chat',
        
        },
        {
          id: 'table',
          title: 'Setting',
          type: 'item',
          icon: 'feather icon-settings',
          url: '/Setting',
        },
        {
          id: 'table',
          title: 'Logout',
          type: 'item',
          icon: 'feather icon-log-out',
          url: '/login',
        }
      ]
    },
  ]
};

export default menuItems;
